import styled from 'styled-components'

export const SortingBarContainer = styled.div`
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: baseline;
  margin: 0;
  padding: 0;
  opacity: ${props => (props.isHidden ? 0 : 1)};
  transition: opacity 250ms ease-in-out;
  font-size: 13px;
  font-weight: 300;

  > span:first-child {
    margin-right: 5px;
  }

  > span + span {
    margin-left: 4px;
  }

  @media screen and (max-width: 767px) {
    ${props =>
      props.withBigTitle &&
      `
      display: block;
      text-align: center;
    `}
  }
`
